import { gsap, TweenLite, TimelineLite, CSSPlugin } from "gsap/all"

gsap.registerPlugin(CSSPlugin)

export default class {
  constructor () {
    this.$dropdown = document.querySelectorAll('.dropdown')

    if (this.$dropdown) {
      this.bindEvents()
    }
  }

  bindEvents () {
    this.$dropdown.forEach(element => {
      new Dropdown(element)
    })
  }
}

class Dropdown {
  constructor (item) {
    this.$dropdown = item
    this.$dropdownButton = this.$dropdown.querySelector('.dropdown__button')
    this.$dropdownContent = this.$dropdown.querySelector('.dropdown__content')

    this.isOpen = false

    if (window.matchMedia("(max-width: 1024px)").matches)
      this.bindEvents()
  }

  bindEvents () {
    this.$dropdownButton.addEventListener('click', () => { this.isOpen ? this.closeAnimation() : this.openAnimation() })
    window.addEventListener('click', (e) => { this.clickOutsideHandler(e) })
  }

  clickOutsideHandler (e) {
    if (!this.$dropdown.contains(e.target)) {
      this.closeAnimation()
    }
  }

  openAnimation () {
    const tl = new TimelineLite()
    TweenLite.set(this.$dropdownContent, { height: 'auto' })
    tl.from(this.$dropdownContent, 0.3, { height: 0, ease: 'power2' })
    tl.to(this.$dropdownContent, 0, { overflow: 'visible' })

    this.$dropdown.classList.add("active")
    this.isOpen = true
  }

  closeAnimation () {
    const tl = new TimelineLite()
    tl.to(this.$dropdownContent, 0, { overflow: 'hidden' })
    tl.to(this.$dropdownContent, 0.3, { height: 0, ease: 'power2' })

    this.$dropdown.classList.remove("active")
    this.isOpen = false
  }
}
